import { useContext } from 'react';
import { GamesContext } from '../context/GamesContext';
import { SearchResults } from './SearchResults';
import { Hero } from './Hero';
import { GameSet } from './GameSet';

export const Games = () => {
  const { gameSets, search, searchResults } = useContext(GamesContext);
  
  if (!gameSets.length) return null

  const hero = gameSets.find(set => set.name === "Hero")
  const all = gameSets.find(set => set.name === "All Games")
  const otherSets = gameSets.filter(set => set.name !== "All Games" && set.name !== "Hero")
  
  const sortedSets = [...otherSets, all]

  return (
    <div className="compensate-header">
      {search.length ? (
        <SearchResults gameIds={searchResults} allGames={all.games} />
      ) : (
        <>
          <Hero game={hero.games[0]} />
          <div>
            {sortedSets.map(gameSet => 
              <GameSet gameSet={gameSet} key={gameSet.id} />
            )}
          </div>
        </>
      )}
    </div>
  );
};
